module.exports = __webpack_public_path__ + "img/image 003.bade1842.png";